// extracted by mini-css-extract-plugin
module.exports = {"criteriaContainer":"GripAnalysisDetails_criteriaContainer_TDVxd","spinAround":"GripAnalysisDetails_spinAround_2YFSK"};